import Vue from 'vue'
import Router from 'vue-router'

import { routers } from './routers'

Vue.use(Router)
const router = new Router({
  mode: 'history',
  routes: routers
})

router.beforeEach((to, from, next) => {
  const customPath = ['/qdmetroLogin', '/ynLogin', '/fsLogin']

  if (process.env.WEBSITE === 0 && to.path === '/login') { // 常规使用，禁止访问登录页
    next({ path: '/' })
  } else if (process.env.WEBSITE > 0 && !customPath.includes(to.path)) {
    // 不同的website类型，跳转至不同的登录界面
    let pathName = ''
    if (process.env.WEBSITE === 1) {
      pathName = 'qdmetroLogin'
    } else if (process.env.WEBSITE === 2) {
      pathName = 'ynLogin'
    } else if (process.env.WEBSITE === 3) {
      pathName = 'fsLogin'
    }

    next({ name: pathName })
  } else {
    next()
  }
})
export default router
